import { Component, Input, OnInit } from '@angular/core';
import { CVLocalizationService } from '../../../reusables/services/cv-localization.service';
import { GamificationService } from '../gamification.service';
import {
    AchievedAchievementDTO, GemHistoryDTOV2, LocalizationMessages, OrderStatus, PointStoreOrder,
    SpendingPointHistoryDTOV2, User, UserProfileDTO
} from '../user-admin.model';

@Component({
    selector: 'cv-gamification-page',
    templateUrl: './gamification-page.component.html',
    styleUrls: ['./gamification-page.component.scss']
})
export class GamificationPageComponent implements OnInit {
    @Input() userProfile: UserProfileDTO;
    @Input() userInfo: User;
    @Input() gemData: GemHistoryDTOV2[];
    @Input() coinData: SpendingPointHistoryDTOV2[];
    @Input() challengeWon: number = 0;

    currentPage: string = "main";
    // level Info
    nextLevelXp: number;
    // BadgeInfo
    badgeList: AchievedAchievementDTO[] = [];
    previewBadges: AchievedAchievementDTO[] = [];
    badgeNum: number = 0;
    // OrderInfo
    orderList: PointStoreOrder[] = [];
    previewOrders: PointStoreOrder[] = []
    orderOrderBy: string = "Title";
    ifShowOrderDetail: number[] = [0, 0, 0];
    LocalizationMessages: LocalizationMessages;
    orderStatus: OrderStatus[] = [];
    adminID: number;
    orderBy: string;
    progressBarWidth: string;

    constructor(
        private service: GamificationService, private locService: CVLocalizationService,
    ) { }

    ngOnInit(): void {
        this.initAsync();
    }

    async initAsync() {
        let loc_marketPlace: Map<string, string> = await this.locService.GetSection("MarketPlace");
        this.LocalizationMessages = {
            "Coins": loc_marketPlace.get("Coins"), "Gems": loc_marketPlace.get("Gems"),
            "Recent_Market_Orders": loc_marketPlace.get("Recent_Market_Orders"), "Badges": loc_marketPlace.get("Badges"),
            "Processing": loc_marketPlace.get("Processing"), "Intransit": loc_marketPlace.get("Intransit"), "Shipped": loc_marketPlace.get("Shipped"),
            "ReadyForPickUp": loc_marketPlace.get("Ready_For_Pickup"), "Complete": loc_marketPlace.get("Complete"),
            "Cancelled": loc_marketPlace.get("Cancelled"), "Checkout_Error": loc_marketPlace.get("Checkout_Error")
        };

        this.orderStatus = [{ value: 1, name: this.LocalizationMessages.Processing, keyLocalization: 'Processing' },
        { value: 2, name: this.LocalizationMessages.Intransit, keyLocalization: 'Intransit' },
        { value: 3, name: this.LocalizationMessages.ReadyForPickUp, keyLocalization: 'Ready_For_Pickup' },
        { value: 4, name: this.LocalizationMessages.Complete, keyLocalization: 'Complete' },
        { value: 5, name: this.LocalizationMessages.Cancelled, keyLocalization: 'Cancelled' }];


        this.service.getCurrentAdminID().then((response) => {
            this.adminID = response;
        });

        this.service.getNextLevelXP(this.userProfile.LoginID, this.userProfile.CurrentLevel).then((response) => {
            this.nextLevelXp = response;
            let progressBarWidth: string;
            if (this.nextLevelXp != 0) {
                progressBarWidth = Math.floor((this.userProfile.CurrentXP / this.nextLevelXp)) > 1 ? '100%' : Math.floor((this.userProfile.CurrentXP / this.nextLevelXp) * 100) + '%';
            } else {
                progressBarWidth = "100%";
            }

            this.progressBarWidth = this.userProfile.CurrentXP == 0 ? "0" : progressBarWidth;

            $(".game_black_progress_value").width(progressBarWidth);
        });

        this.service.getAchievedAchievements(this.userProfile.LoginID).then((response) => {
            this.badgeList = response;
            this.badgeList.forEach((el) => {
                this.badgeNum += el.earnedDates.length;
                el.LastDate = el.earnedDates[0];
            })
        });

        this.service.getRecentAchievedAchievements(this.userProfile.LoginID).then((response) => {
            this.previewBadges = response;
            this.previewBadges.forEach((el) => {
                el.earnedDate = el.earnedDates[0].substring(2, 10);
                var day = el.earnedDate.substring(6, 8);
                var month = el.earnedDate.substring(3, 5);
                var year = el.earnedDate.substring(0, 2);
                el.earnedDate = month + "/" + day + "/" + year;

            });
        });

        this.service.getPointStoreOrdersByLoginID(this.userProfile.LoginID).then((response) => {
            if (response.length > 0) {
                this.orderList = response;

                this.orderList.forEach((el) => {
                    el.DateOrdered = el.DateOrdered.substring(2, 10);
                    var day = el.DateOrdered.substring(6, 8);
                    var month = el.DateOrdered.substring(3, 5);
                    var year = el.DateOrdered.substring(0, 2);
                    el.DateOrdered = month + "/" + day + "/" + year;
                });

                if (this.orderStatus != undefined) {
                    for (var i = 0; i < this.orderList.length; i++) {
                        this.orderStatus.forEach((el) => {
                            if (el.value == this.orderList[i].OrderStatus) {
                                this.orderList[i].OrderStatusName = el.name;
                                return;
                            }
                        });
                    };
                }

                this.previewOrders = [];
                for (let i = 0; i < this.orderList.length && i < 4; ++i) {
                    this.previewOrders.push(this.orderList[this.orderList.length - (i + 1)]);
                }
            }
        });

        if (this.orderStatus != undefined) {
            this.orderStatus.forEach((el) => {
                if (loc_marketPlace.get(el.keyLocalization) != null) {
                    el.name = loc_marketPlace.get(el.keyLocalization);
                }
            });
        }
    }

    changeOrder(order) {
        if (this.orderBy === order)
            this.orderBy = ("-" + order);
        else
            this.orderBy = order;
    };

    changeCurrentPage(page) {
        this.currentPage = page;
    };

    expandOrder(index) {
        if (this.ifShowOrderDetail[index] == 0) {
            this.ifShowOrderDetail[index] = 1;
        } else {
            this.ifShowOrderDetail[index] = 0;
        }
    }
}
